<template>
    <section>
      <div class="container" v-if="addOns.customerSatisfaction" >
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div class="container">
              <h1 class="title" style="color:#3e8ed0">Customer satisfaction</h1>
              <h5 class="subtitle">Statistics for customer satisfaction.</h5>
            </div>
          </div>
        </div>
        <div class="columns is-multiline is-mobile">

            <div class="column is-3 is-offset-1" >
            <b-field label="Date Range:">
        <b-datepicker
            placeholder="Click to select..."
            v-model="dates"
            range>
        </b-datepicker>
    </b-field>
            </div>

            <div class="column is-3 is-offset-0" >
    <b-field label="Device:">
      <b-select v-model="selectedDevice">
              <option value="all">All devices</option>
              <option v-for="(device, id) in devicesToShow" :key="id" :value="id">{{device.name}}</option>
            </b-select>
            </b-field>
            </div>

            <div v-if="selectedDevice !== 'all'" class="column is-3 is-offset-0" >
    <b-field label="Front desk:">
      <b-select v-model="selectedFrontDesk">
              <option value="all">All front desks</option>
              <option v-for="(fd, id) in frontDesks" :key="id" :value="id">{{fd.name}}</option>
            </b-select>
            </b-field>
            </div>
        </div>
        <GChart
        :type="chartType"
        :data="chartData"
        :options="chartOptions"
    />

    <div class="columns is-multiline is-mobile">

<div class="column is-3 is-offset-1" >
    <b-button type="is-info">
        <download-excel :data="exportData" :fields="jsonFields" name="CustomerSatisfaction.csv" type="csv" :escapeCsv="falseString">
                Export Data
              </download-excel>
    </b-button>
</div>
</div>
      </div>
      <div v-else class="container">
      </div>
    </section>
  </template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'CustomerSatisfaction',
  data: () => {
    return {
      resultsArray: [],
      dates: [],
      selectedDevice: 'all',
      selectedFrontDesk: 'all',
      frontDesks: {},
      devicesToShow: {},
      exportData: null,
      falseString: false,
      jsonFields: {
        'Device': 'device',
        'Front desk': 'frontDesk',
        'Time': 'time',
        'Rating': 'rating'
      },
      chartData: [],
      chartType: 'ColumnChart',
      chartOptions: {
        width: 1100,
        height: 400,
        fontName: 'Nunito',
        title: '',
        is3D: true,
        bar: { groupWidth: '90%' },
        vAxis: {format: '0'},
        yAxis: {
          viewWindow: {
            min: 0
          }
        }
      }
    }
  },
  components: {
    GChart
  },
  computed: {
    customerSatisfaction () {
      return this.$store.state.customerSatisfaction
    },
    frontDesk () {
      return this.$store.state.frontDesk
    },
    addOns () {
      return this.$store.state.addOns
    },
    devices () {
      return this.$store.state.devices
    }
  },
  watch: {
    dates () {
      this.resultsArray = [0, 0, 0, 0, 0]

      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedDevice === 'all') {
        this.calculateChartData(startD, endD)
      } else {
        if (this.selectedFrontDesk === 'all') {
          this.calculateChartDataByDevice(startD, endD, this.selectedDevice)
        } else {
          this.calculateChartDataByFrontDesk(startD, endD, this.selectedDevice, this.selectedFrontDesk)
        }
      }
    },
    selectedDevice () {
      // this.selectedFrontDesk = 'all'

      this.resultsArray = [0, 0, 0, 0, 0]

      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedDevice === 'all') {
        this.calculateChartData(startD, endD)
      } else {
        this.getFrontDesksByDevice(this.selectedDevice)
        this.calculateChartDataByDevice(startD, endD, this.selectedDevice)
      }
    },
    selectedFrontDesk () {
      this.resultsArray = [0, 0, 0, 0, 0]

      let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
      let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
      let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
      let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

      if (this.selectedFrontDesk === 'all') {
        this.calculateChartDataByDevice(startD, endD, this.selectedDevice)
      } else {
        this.calculateChartDataByFrontDesk(startD, endD, this.selectedDevice, this.selectedFrontDesk)
      }
    }
  },
  mounted: function () {
    this.getDevices()
    this.getFrontDeskNames()

    this.resultsArray = [0, 0, 0, 0, 0]

    var start = new Date()
    var end = new Date()
    start.setDate(start.getDate() - 6)
    end.setDate(end.getDate())
    this.dates = [start, end]
    let startDateArray = this.dates[0].toLocaleDateString('en-GB').split('/')
    let startD = new Date(startDateArray[2], parseInt(startDateArray[1]) - 1, startDateArray[0])
    let endDateArray = this.dates[1].toLocaleDateString('en-GB').split('/')
    let endD = new Date(endDateArray[2], parseInt(endDateArray[1]) - 1, endDateArray[0])

    this.calculateChartData(startD, endD)
  },
  methods: {
    calculateChartData (startD, endD) {
      if (this.customerSatisfaction) {
        this.exportData = []
        for (let deviceId in this.customerSatisfaction) {
          var deviceName = this.$store.getters.getDeviceName(deviceId)
          let satisfactionPerDevice = this.customerSatisfaction[deviceId]
          for (let recordId in satisfactionPerDevice) {
            let record = satisfactionPerDevice[recordId]
            let date = recordId.split(' ')[0]
            let dateArray = date.split('-')
            let dateD = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0])
            if (dateD >= startD && dateD <= endD) {
              this.exportData.push({
                'device': deviceName,
                'frontDesk': this.frontDeskNames[record.fdid],
                'time': record.time,
                'rating': record.rate
              })
              switch (record.rate) {
                case 1:
                  this.resultsArray[0] += 1
                  break
                case 2:
                  this.resultsArray[1] += 1
                  break
                case 3:
                  this.resultsArray[2] += 1
                  break
                case 4:
                  this.resultsArray[3] += 1
                  break
                case 5:
                  this.resultsArray[4] += 1
                  break
              }
            }
          }
        }
        let chD = [['Rating', 'Quantity']]
        for (let i = 0; i < 5; i++) {
          chD.push([i + 1, this.resultsArray[i]])
        }
        this.chartData = chD

        if (startD.getTime() === endD.getTime()) {
          this.chartOptions.title = 'All data, ' + startD.toLocaleDateString('en-GB')
        } else {
          this.chartOptions.title = 'All data, ' + startD.toLocaleDateString('en-GB') + ' - ' + endD.toLocaleDateString('en-GB')
        }
      }
    },
    calculateChartDataByDevice (startD, endD, devId) {
      if (this.customerSatisfaction) {
        this.exportData = []
        for (let deviceId in this.customerSatisfaction) {
          if (deviceId === devId) {
            let satisfactionPerDevice = this.customerSatisfaction[deviceId]
            for (let recordId in satisfactionPerDevice) {
              let record = satisfactionPerDevice[recordId]
              let date = recordId.split(' ')[0]
              let dateArray = date.split('-')
              let dateD = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0])
              if (dateD >= startD && dateD <= endD) {
                let devName = this.$store.getters.getDeviceName(this.selectedDevice)
                this.exportData.push({
                  'device': devName,
                  'frontDesk': this.frontDeskNames[record.fdid],
                  'time': record.time,
                  'rating': record.rate
                })
                switch (record.rate) {
                  case 1:
                    this.resultsArray[0] += 1
                    break
                  case 2:
                    this.resultsArray[1] += 1
                    break
                  case 3:
                    this.resultsArray[2] += 1
                    break
                  case 4:
                    this.resultsArray[3] += 1
                    break
                  case 5:
                    this.resultsArray[4] += 1
                    break
                }
              }
            }
          }
        }
        let chD = [['Rating', 'Quantity']]
        for (let i = 0; i < 5; i++) {
          chD.push([i + 1, this.resultsArray[i]])
        }
        this.chartData = chD

        let deviceName = this.$store.getters.getDeviceName(this.selectedDevice)
        if (startD.getTime() === endD.getTime()) {
          this.chartOptions.title = deviceName + ', ' + startD.toLocaleDateString('en-GB')
        } else {
          this.chartOptions.title = deviceName + ', ' + startD.toLocaleDateString('en-GB') + ' - ' + endD.toLocaleDateString('en-GB')
        }
      }
    },
    calculateChartDataByFrontDesk (startD, endD, devId, fdId) {
      if (this.customerSatisfaction) {
        this.exportData = []
        for (let deviceId in this.customerSatisfaction) {
          if (deviceId === devId) {
            let satisfactionPerDevice = this.customerSatisfaction[deviceId]
            for (let recordId in satisfactionPerDevice) {
              let record = satisfactionPerDevice[recordId]
              if (record.fdid === fdId) {
                let date = recordId.split(' ')[0]
                let dateArray = date.split('-')
                let dateD = new Date(dateArray[2], parseInt(dateArray[1]) - 1, dateArray[0])
                if (dateD >= startD && dateD <= endD) {
                  let devName = this.$store.getters.getDeviceName(this.selectedDevice)
                  this.exportData.push({
                    'device': devName,
                    'frontDesk': this.frontDeskNames[record.fdid],
                    'time': record.time,
                    'rating': record.rate
                  })
                  switch (record.rate) {
                    case 1:
                      this.resultsArray[0] += 1
                      break
                    case 2:
                      this.resultsArray[1] += 1
                      break
                    case 3:
                      this.resultsArray[2] += 1
                      break
                    case 4:
                      this.resultsArray[3] += 1
                      break
                    case 5:
                      this.resultsArray[4] += 1
                      break
                  }
                }
              }
            }
          }
        }
        let chD = [['Rating', 'Quantity']]
        for (let i = 0; i < 5; i++) {
          chD.push([i + 1, this.resultsArray[i]])
        }
        this.chartData = chD

        let frontDeskName = this.frontDeskNames[this.selectedFrontDesk]
        let deviceName = this.$store.getters.getDeviceName(this.selectedDevice)

        if (startD.getTime() === endD.getTime()) {
          this.chartOptions.title = frontDeskName + ', ' + deviceName + ', ' + startD.toLocaleDateString('en-GB')
        } else {
          this.chartOptions.title = frontDeskName + ', ' + deviceName + ', ' + startD.toLocaleDateString('en-GB') + ' - ' + endD.toLocaleDateString('en-GB')
        }
      }
    },
    getFrontDesksByDevice (devId) {
      var frontDesksArray = []
      this.frontDesks = {}
      if (this.frontDesk) {
        for (let deviceId in this.frontDesk) {
          if (deviceId === devId) {
            let frontDesksPerDevice = this.frontDesk[deviceId]
            for (let frontDeskId in frontDesksPerDevice) {
              frontDesksArray.push({id: frontDeskId, name: frontDesksPerDevice[frontDeskId].name})
            }
          }
        }
        frontDesksArray.forEach(fd => {
          this.frontDesks[fd.id] = fd
        })
      }
    },
    getFrontDeskNames () {
      if (this.frontDesk) {
        this.frontDeskNames = {}
        for (let deviceId in this.frontDesk) {
          let frontDesksPerDevice = this.frontDesk[deviceId]
          for (let frontDeskId in frontDesksPerDevice) {
            this.frontDeskNames[frontDeskId] = frontDesksPerDevice[frontDeskId].name
          }
        }
      }
    },
    getDevices () {
      var devicesArray = []
      this.devicesToShow = {}
      if (this.frontDesk) {
        for (let deviceId in this.frontDesk) {
          for (let devId in this.devices) {
            if (deviceId === devId) {
              devicesArray.push({id: deviceId, name: this.devices[deviceId].name})
            }
          }
        }
        devicesArray.forEach(did => {
          this.devicesToShow[did.id] = did
        })
      }
    }
  }
}
</script>
<style scoped>
.topPadding {
  padding-top: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/customersatisfaction/CustomerSatisfaction.vue